import { useContext } from "react";

import { SurveyContext } from "./survey.context";

export function useIsSurvey(): boolean {
  return useContext(SurveyContext).isSurvey;
}
